/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Completed_OnInputs */



/**
* | output |
* | --- |
* | "Completed On" |
*
* @param {Completed_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const completed_on = /** @type {((inputs?: Completed_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Completed_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgeschlossen am")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completato il")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Completado el")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完了日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Concluído em")
	return /** @type {LocalizedString} */ ("Completed On")
});